var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"left-text":_vm.leftText,"right-text":_vm.rightText,"left-arrow":_vm.leftArrow},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }